export default __webpack_public_path__ + "static/P1020486_developed-44967a89844c29c9496f569b699959ec.jpg";